// Hazır Email Şablonları

export const emailTemplates = [
  // ======= KABİN MEMURU ŞABLONLARI (Re-engagement için) =======
  
  {
    id: 'cabin-crew-reengagement',
    name: 'Geri Dönüş Daveti',
    category: 'Kabin Memuru',
    description: 'Başvuran ama katılmayan adaylara geri dönüş',
    thumbnail: 'https://images.unsplash.com/photo-1436491865332-7a61a109cc05?w=400&h=300&fit=crop',
    subject: '{{name}}, kabin memuru hayaliniz için geri döndük!',
    html: `<!DOCTYPE html>
<html>
<head><meta charset="utf-8"></head>
<body style="margin:0;padding:0;background:#fff;font-family:Arial,sans-serif;">
  <table width="100%" style="background:#fff;padding:20px;">
    <tr><td align="center">
      <table width="600" style="background:#fff;">
        <tr><td style="padding:40px 20px;">
          <p style="color:#0f172a;font-size:16px;line-height:1.6;margin:0 0 20px 0;">
            Merhaba {{name}},
          </p>
          
          <p style="color:#0f172a;font-size:16px;line-height:1.8;margin:0 0 20px 0;">
            Bir süre önce kabin memurluğu eğitimimize başvurmuştunuz ama bir şekilde yollarımız ayrıldı. 
            Sizi özledik! ✈️
          </p>
          
          <p style="color:#0f172a;font-size:16px;line-height:1.8;margin:0 0 20px 0;">
            Kabin memuru hayalinizden vazgeçmediniz değil mi? Size harika bir haberim var - 
            eğitim programımızı <strong>tamamen yeniledik</strong> ve daha önce hiç olmadığı kadar kapsamlı hale getirdik!
          </p>
          
          <div style="background:#f0f9ff;padding:25px;border-radius:12px;margin:30px 0;border-left:4px solid #3b82f6;">
            <p style="color:#1e40af;font-size:16px;margin:0 0 15px 0;font-weight:600;">
              🎯 Yeni Programımızda:
            </p>
            <ul style="color:#1e40af;font-size:15px;margin:0;padding-left:20px;line-height:2;">
              <li><strong>İngilizce Canlı Yayınlar</strong> - Native speaker'larla gerçek zamanlı pratik</li>
              <li><strong>Öğretme Garantisi</strong> - Öğrenmezseniz tekrar ücretsiz</li>
              <li><strong>Havacılık İngilizcesi</strong> - Cockpit communication'dan PA announcement'a</li>
              <li><strong>Mülakat Provası</strong> - 1-1 gerçek mülakat simülasyonu</li>
            </ul>
          </div>
          
          <p style="color:#0f172a;font-size:16px;line-height:1.8;margin:0 0 20px 0;">
            <strong>{{name}}, hayalleriniz için ikinci bir şans.</strong> Bu mail'e cevap yazın veya 
            aşağıdaki butona tıklayın, size özel bir fırsat hazırlayayım.
          </p>
          
          <div style="text-align:center;margin:30px 0;">
            <a href="{{register_link}}" style="display:inline-block;background:#3b82f6;color:#fff;padding:16px 40px;text-decoration:none;border-radius:8px;font-weight:600;font-size:16px;">
              Evet, Tekrar Başlamak İstiyorum ✈️
            </a>
          </div>
          
          <p style="color:#0f172a;font-size:16px;line-height:1.8;margin:25px 0 0 0;">
            Gökyüzü sizi bekliyor! 💙
          </p>
          
          <p style="color:#0f172a;font-size:16px;line-height:1.6;margin:20px 0 0 0;">
            Saygılarımla,<br>
            <strong>{{sender_name}}</strong><br>
            <span style="color:#64748b;font-size:14px;">Kabin Memurluğu Eğitim Uzmanı</span>
          </p>
        </td></tr>
      </table>
    </td></tr>
  </table>
</body>
</html>`
  },
  
  {
    id: 'cabin-crew-new-features',
    name: 'Yeni Özellikler Duyurusu',
    category: 'Kabin Memuru',
    description: 'Yenilenen programın detaylı tanıtımı',
    thumbnail: 'https://images.unsplash.com/photo-1569629743817-70d8db6c323b?w=400&h=300&fit=crop',
    subject: '🔥 Eğitim programımız artık 3 kat daha güçlü - {{name}}',
    html: `<!DOCTYPE html>
<html>
<head><meta charset="utf-8"></head>
<body style="margin:0;padding:0;background:#fff;font-family:Arial,sans-serif;">
  <table width="100%" style="background:#fff;padding:20px;">
    <tr><td align="center">
      <table width="600" style="background:#fff;">
        <tr><td style="padding:40px 20px;">
          <div style="text-align:center;margin-bottom:30px;">
            <span style="font-size:48px;">✈️</span>
          </div>
          
          <p style="color:#0f172a;font-size:16px;line-height:1.6;margin:0 0 20px 0;">
            Merhaba {{name}},
          </p>
          
          <p style="color:#0f172a;font-size:16px;line-height:1.8;margin:0 0 20px 0;">
            Kabin memurluğu eğitim sektöründe bir devrim yaptık ve siz bunun ilk tanıklarından biri olabilirsiniz!
          </p>
          
          <div style="background:#fff7ed;padding:30px;border-radius:12px;margin:30px 0;border:2px solid #fb923c;">
            <h3 style="color:#ea580c;margin:0 0 20px 0;font-size:20px;text-align:center;">
              🚀 Türkiye'nin En Kapsamlı Programı
            </h3>
            
            <div style="background:#fff;padding:20px;border-radius:8px;margin-bottom:15px;">
              <p style="color:#0f172a;font-size:15px;margin:0 0 8px 0;font-weight:600;">
                ✅ İngilizce Canlı Yayınlar
              </p>
              <p style="color:#64748b;font-size:14px;margin:0;line-height:1.6;">
                Native speaker eğitmenlerle her gün canlı dersler. Speaking'i gerçek zamanlı geliştirin.
              </p>
            </div>
            
            <div style="background:#fff;padding:20px;border-radius:8px;margin-bottom:15px;">
              <p style="color:#0f172a;font-size:15px;margin:0 0 8px 0;font-weight:600;">
                ✅ Diksiyon & İşaret Dili Eğitimleri
              </p>
              <p style="color:#64748b;font-size:14px;margin:0;line-height:1.6;">
                Profesyonel diksiyon koçu eşliğinde konuşma sanatı + işaret dili sertifikası.
              </p>
            </div>
            
            <div style="background:#fff;padding:20px;border-radius:8px;margin-bottom:15px;">
              <p style="color:#0f172a;font-size:15px;margin:0 0 8px 0;font-weight:600;">
                ✅ Havacılık İngilizcesi Uzmanlığı
              </p>
              <p style="color:#64748b;font-size:14px;margin:0;line-height:1.6;">
                ICAO standartlarında havacılık terminolojisi. Cockpit-cabin communication dahil.
              </p>
            </div>
            
            <div style="background:#fff;padding:20px;border-radius:8px;margin-bottom:15px;">
              <p style="color:#0f172a;font-size:15px;margin:0 0 8px 0;font-weight:600;">
                ✅ Mock-up Eğitimleri
              </p>
              <p style="color:#64748b;font-size:14px;margin:0;line-height:1.6;">
                Gerçek uçak kabini simülasyonunda pratik. Safety demo'dan service'e her şey.
              </p>
            </div>
            
            <div style="background:#fff;padding:20px;border-radius:8px;">
              <p style="color:#0f172a;font-size:15px;margin:0 0 8px 0;font-weight:600;">
                ✅ 1-1 Mülakat Provası
              </p>
              <p style="color:#64748b;font-size:14px;margin:0;line-height:1.6;">
                Eski kabin amirlerinden gerçek mülakat simülasyonu. Güvenle mülakata girin.
              </p>
            </div>
          </div>
          
          <div style="background:#ecfdf5;padding:20px;border-radius:8px;margin:25px 0;text-align:center;">
            <p style="color:#065f46;font-size:16px;margin:0;font-weight:600;">
              🎁 ÖZEL: İlk 20 kayıt için %30 erken kayıt indirimi!
            </p>
          </div>
          
          <div style="text-align:center;margin:30px 0;">
            <a href="{{info_link}}" style="display:inline-block;background:#ea580c;color:#fff;padding:16px 40px;text-decoration:none;border-radius:8px;font-weight:600;font-size:16px;">
              Detaylı Bilgi Al
            </a>
          </div>
          
          <p style="color:#0f172a;font-size:16px;line-height:1.6;margin:20px 0 0 0;">
            Kabin memuru olma yolculuğunuzda yanınızdayız,<br>
            <strong>{{sender_name}}</strong>
          </p>
        </td></tr>
      </table>
    </td></tr>
  </table>
</body>
</html>`
  },
  
  {
    id: 'cabin-crew-success-story',
    name: 'Başarı Hikayesi',
    category: 'Kabin Memuru',
    description: 'Mezun öğrencilerin başarı hikayeleri',
    thumbnail: 'https://images.unsplash.com/photo-1539185441755-769473a23570?w=400&h=300&fit=crop',
    subject: '{{name}}, Ayşe de sizin gibi başvurmuştu - şimdi THY\'de!',
    html: `<!DOCTYPE html>
<html>
<head><meta charset="utf-8"></head>
<body style="margin:0;padding:0;background:#fff;font-family:Arial,sans-serif;">
  <table width="100%" style="background:#fff;padding:20px;">
    <tr><td align="center">
      <table width="600" style="background:#fff;">
        <tr><td style="padding:40px 20px;">
          <p style="color:#0f172a;font-size:16px;line-height:1.6;margin:0 0 20px 0;">
            Merhaba {{name}},
          </p>
          
          <p style="color:#0f172a;font-size:16px;line-height:1.8;margin:0 0 20px 0;">
            Size bir hikaye anlatmak istiyorum...
          </p>
          
          <div style="background:#f8fafc;padding:30px;border-radius:12px;margin:30px 0;border:2px solid #e2e8f0;">
            <div style="text-align:center;margin-bottom:20px;">
              <div style="width:80px;height:80px;background:#dbeafe;border-radius:50%;margin:0 auto;display:flex;align-items:center;justify-content:center;font-size:36px;">
                👩‍✈️
              </div>
            </div>
            
            <h3 style="color:#0f172a;margin:0 0 15px 0;font-size:20px;text-align:center;">
              Ayşe'nin Hikayesi
            </h3>
            
            <p style="color:#64748b;font-size:15px;margin:0 0 15px 0;line-height:1.8;font-style:italic;">
              "6 ay önce sizin gibi başvuru yapmıştım ama cesaret edemedim. İngilizcem yeterli mi, 
              mülakata hazır mıyım diye sürekli düşünüyordum. Bir gün 'yeter artık' dedim ve 
              eğitime katıldım..."
            </p>
            
            <div style="background:#ecfdf5;padding:20px;border-radius:8px;margin:20px 0;">
              <p style="color:#065f46;font-size:14px;margin:0 0 10px 0;font-weight:600;">
                Ayşe'nin 3 Aylık Yolculuğu:
              </p>
              <ul style="color:#065f46;font-size:14px;margin:0;padding-left:20px;line-height:2;">
                <li>İngilizce seviyesi: A2 → B2 (TOEIC 850)</li>
                <li>Mülakat provası: 12 seans</li>
                <li>Mock-up eğitimi: 20 saat</li>
                <li><strong>Sonuç: THY kabin memuru! 🎉</strong></li>
              </ul>
            </div>
            
            <p style="color:#64748b;font-size:15px;margin:15px 0 0 0;line-height:1.8;font-style:italic;">
              "Geriye dönüp baktığımda tek pişmanlığım erken başlamamak. Eğer siz de benim gibi 
              düşünüyorsanız, bir adım atın. Kabin memurluğu hayalinizi ertelemek yerine 
              bugün başlayın!"
            </p>
            
            <p style="color:#0f172a;font-size:14px;margin:15px 0 0 0;text-align:right;font-weight:600;">
              - Ayşe K., THY Kabin Memuru
            </p>
          </div>
          
          <p style="color:#0f172a;font-size:16px;line-height:1.8;margin:0 0 20px 0;">
            <strong>{{name}}, sırada siz varsınız!</strong>
          </p>
          
          <p style="color:#0f172a;font-size:16px;line-height:1.8;margin:0 0 25px 0;">
            Ayşe gibi yüzlerce öğrencimiz hayallerine ulaştı. Siz de onlardan biri olabilirsiniz. 
            Bu mail'e cevap yazın, sizinle özel olarak konuşalım.
          </p>
          
          <div style="text-align:center;margin:30px 0;">
            <a href="{{story_link}}" style="display:inline-block;background:#10b981;color:#fff;padding:16px 40px;text-decoration:none;border-radius:8px;font-weight:600;font-size:16px;">
              Daha Fazla Başarı Hikayesi
            </a>
          </div>
          
          <p style="color:#0f172a;font-size:16px;line-height:1.6;margin:20px 0 0 0;">
            Hayallerinize birlikte ulaşalım,<br>
            <strong>{{sender_name}}</strong>
          </p>
        </td></tr>
      </table>
    </td></tr>
  </table>
</body>
</html>`
  },
  
  {
    id: 'cabin-crew-english-focus',
    name: 'İngilizce Odaklı',
    category: 'Kabin Memuru',
    description: 'İngilizce eğitim vurgusu',
    thumbnail: 'https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=400&h=300&fit=crop',
    subject: '{{name}}, İngilizceniz kabin memurluğuna engel olmasın!',
    html: `<!DOCTYPE html>
<html>
<head><meta charset="utf-8"></head>
<body style="margin:0;padding:0;background:#fff;font-family:Arial,sans-serif;">
  <table width="100%" style="background:#fff;padding:20px;">
    <tr><td align="center">
      <table width="600" style="background:#fff;">
        <tr><td style="padding:40px 20px;">
          <p style="color:#0f172a;font-size:16px;line-height:1.6;margin:0 0 20px 0;">
            Merhaba {{name}},
          </p>
          
          <p style="color:#0f172a;font-size:16px;line-height:1.8;margin:0 0 20px 0;">
            Kabin memuru olmak istiyorsunuz ama bir şey sizi durduruyor: <strong>İngilizce</strong>. 
            Değil mi?
          </p>
          
          <p style="color:#0f172a;font-size:16px;line-height:1.8;margin:0 0 20px 0;">
            "İngilizcemi geliştirmeliyim ama nasıl?" diye düşünüyorsanız, size müjdem var! 🎉
          </p>
          
          <div style="background:#dbeafe;padding:30px;border-radius:12px;margin:30px 0;border-left:4px solid #3b82f6;">
            <h3 style="color:#1e40af;margin:0 0 20px 0;font-size:20px;">
              🗣️ Canlı İngilizce Programımız
            </h3>
            
            <div style="background:#fff;padding:20px;border-radius:8px;margin-bottom:15px;">
              <p style="color:#0f172a;font-size:15px;margin:0 0 8px 0;font-weight:600;">
                Her Gün Canlı Ders
              </p>
              <p style="color:#64748b;font-size:14px;margin:0;">
                Native speaker eğitmenlerle zoom üzerinden gerçek zamanlı pratik. 
                Sadece dinlemiyorsunuz, konuşuyorsunuz!
              </p>
            </div>
            
            <div style="background:#fff;padding:20px;border-radius:8px;margin-bottom:15px;">
              <p style="color:#0f172a;font-size:15px;margin:0 0 8px 0;font-weight:600;">
                Havacılık İngilizcesi Uzmanlığı
              </p>
              <p style="color:#64748b;font-size:14px;margin:0;">
                "Ladies and gentlemen, welcome aboard" cümlesinden başlayıp, 
                acil durum anonslarına kadar tüm aviation vocabulary.
              </p>
            </div>
            
            <div style="background:#fff;padding:20px;border-radius:8px;margin-bottom:15px;">
              <p style="color:#0f172a;font-size:15px;margin:0 0 8px 0;font-weight:600;">
                Mülakat İngilizcesi
              </p>
              <p style="color:#64748b;font-size:14px;margin:0;">
                "Tell me about yourself", "Why cabin crew?" gibi sıkça sorulan soruları 
                akıcı şekilde cevaplayın. 1-1 practice sessions.
              </p>
            </div>
            
            <div style="background:#fff;padding:20px;border-radius:8px;">
              <p style="color:#0f172a;font-size:15px;margin:0 0 8px 0;font-weight:600;">
                Öğretme Garantisi
              </p>
              <p style="color:#64748b;font-size:14px;margin:0;">
                3 ay sonunda hedef seviyeye ulaşamazsanız, <strong>ücretsiz devam edin</strong>. 
                Risksiz öğrenin!
              </p>
            </div>
          </div>
          
          <div style="background:#fef3c7;padding:20px;border-radius:8px;margin:25px 0;text-align:center;">
            <p style="color:#92400e;font-size:15px;margin:0 0 10px 0;font-weight:600;">
              📊 Öğrencilerimizin Ortalama İlerleme:
            </p>
            <p style="color:#92400e;font-size:32px;margin:0;font-weight:700;">
              A2 → B2
            </p>
            <p style="color:#92400e;font-size:14px;margin:5px 0 0 0;">
              sadece 3 ayda!
            </p>
          </div>
          
          <p style="color:#0f172a;font-size:16px;line-height:1.8;margin:0 0 25px 0;">
            {{name}}, İngilizce artık bir engel değil - bir fırsat! Bu mail'e cevap yazın, 
            size ücretsiz seviye tespit edelim.
          </p>
          
          <div style="text-align:center;margin:30px 0;">
            <a href="{{english_link}}" style="display:inline-block;background:#3b82f6;color:#fff;padding:16px 40px;text-decoration:none;border-radius:8px;font-weight:600;font-size:16px;">
              Ücretsiz Seviye Testi Al
            </a>
          </div>
          
          <p style="color:#0f172a;font-size:16px;line-height:1.6;margin:20px 0 0 0;">
            English is not a barrier anymore! 🚀<br>
            <strong>{{sender_name}}</strong>
          </p>
        </td></tr>
      </table>
    </td></tr>
  </table>
</body>
</html>`
  },
  
  {
    id: 'cabin-crew-interview-prep',
    name: 'Mülakat Hazırlığı',
    category: 'Kabin Memuru',
    description: 'Mülakat provası vurgusu',
    thumbnail: 'https://images.unsplash.com/photo-1521737604893-d14cc237f11d?w=400&h=300&fit=crop',
    subject: '{{name}}, mülakata hazır mısınız? Çoğu aday burada eleniyor!',
    html: `<!DOCTYPE html>
<html>
<head><meta charset="utf-8"></head>
<body style="margin:0;padding:0;background:#fff;font-family:Arial,sans-serif;">
  <table width="100%" style="background:#fff;padding:20px;">
    <tr><td align="center">
      <table width="600" style="background:#fff;">
        <tr><td style="padding:40px 20px;">
          <p style="color:#0f172a;font-size:16px;line-height:1.6;margin:0 0 20px 0;">
            Merhaba {{name}},
          </p>
          
          <p style="color:#0f172a;font-size:16px;line-height:1.8;margin:0 0 20px 0;">
            Size şok edici bir istatistik söyleyeceğim...
          </p>
          
          <div style="background:#fef2f2;padding:25px;border-radius:12px;margin:30px 0;border-left:4px solid #ef4444;text-align:center;">
            <p style="color:#991b1b;font-size:48px;margin:0;font-weight:900;">
              %73
            </p>
            <p style="color:#991b1b;font-size:16px;margin:10px 0 0 0;font-weight:600;">
              Kabin memuru adayları mülakat aşamasında eleniyor!
            </p>
          </div>
          
          <p style="color:#0f172a;font-size:16px;line-height:1.8;margin:0 0 20px 0;">
            Neden mi? Çünkü çoğu aday <strong>hazırlıksız</strong> gidiyor. İngilizce biliyor, 
            özgeçmişi güzel ama mülakatta ne söyleyeceğini bilmiyor.
          </p>
          
          <div style="background:#f0fdf4;padding:30px;border-radius:12px;margin:30px 0;">
            <h3 style="color:#065f46;margin:0 0 20px 0;font-size:20px;">
              🎯 Bizim Mülakat Provası Programı
            </h3>
            
            <div style="background:#fff;padding:20px;border-radius:8px;margin-bottom:15px;border-left:3px solid #10b981;">
              <p style="color:#0f172a;font-size:15px;margin:0 0 8px 0;font-weight:600;">
                1. Gerçek Mülakat Simülasyonu
              </p>
              <p style="color:#64748b;font-size:14px;margin:0;">
                Eski kabin amirleriyle 1-1 mülakat. Gerçek sorular, gerçek değerlendirme. 
                Stres testinden grooming kontrolüne her şey.
              </p>
            </div>
            
            <div style="background:#fff;padding:20px;border-radius:8px;margin-bottom:15px;border-left:3px solid #10b981;">
              <p style="color:#0f172a;font-size:15px;margin:0 0 8px 0;font-weight:600;">
                2. Soru Bankası ve Cevap Stratejileri
              </p>
              <p style="color:#64748b;font-size:14px;margin:0;">
                "Why do you want to be a cabin crew?" sorusuna 100 farklı aday 100 farklı 
                cevap verir. Hangisi doğru? Size öğretiyoruz.
              </p>
            </div>
            
            <div style="background:#fff;padding:20px;border-radius:8px;margin-bottom:15px;border-left:3px solid #10b981;">
              <p style="color:#0f172a;font-size:15px;margin:0 0 8px 0;font-weight:600;">
                3. Body Language & First Impression
              </p>
              <p style="color:#64748b;font-size:14px;margin:0;">
                İlk 30 saniyede karar veriliyor. Nasıl giyinmeli, nasıl oturmalı, 
                el hareketleri nasıl olmalı? Video analizi ile öğrenin.
              </p>
            </div>
            
            <div style="background:#fff;padding:20px;border-radius:8px;border-left:3px solid #10b981;">
              <p style="color:#0f172a;font-size:15px;margin:0 0 8px 0;font-weight:600;">
                4. Group Discussion Provası
              </p>
              <p style="color:#64748b;font-size:14px;margin:0;">
                Havayolu mülak atlarının en zorlarından biri. Nasıl lider olunur ama 
                agresif olunmaz? Nasıl konuşulur ama dominant olmadan?
              </p>
            </div>
          </div>
          
          <div style="background:#fffbeb;padding:20px;border-radius:8px;margin:25px 0;text-align:center;">
            <p style="color:#92400e;font-size:15px;margin:0;font-weight:600;">
              💡 Öğrencilerimizin %89'u ilk mülakatlarında başarılı oluyor!
            </p>
          </div>
          
          <p style="color:#0f172a;font-size:16px;line-height:1.8;margin:0 0 25px 0;">
            {{name}}, mülakatta %73'lük elenen gruba değil, %27'lik başarılı gruba girmek 
            istiyorsanız, hazırlık şart!
          </p>
          
          <div style="text-align:center;margin:30px 0;">
            <a href="{{interview_link}}" style="display:inline-block;background:#10b981;color:#fff;padding:16px 40px;text-decoration:none;border-radius:8px;font-weight:600;font-size:16px;">
              Ücretsiz Mülakat Değerlendirmesi Al
            </a>
          </div>
          
          <p style="color:#0f172a;font-size:16px;line-height:1.6;margin:20px 0 0 0;">
            Mülakata hazır girin, işe hazır çıkın! 🎯<br>
            <strong>{{sender_name}}</strong><br>
            <span style="color:#64748b;font-size:14px;">Eski THY Kabin Amiri</span>
          </p>
        </td></tr>
      </table>
    </td></tr>
  </table>
</body>
</html>`
  },
  
  {
    id: 'cabin-crew-last-chance',
    name: 'Son Şans',
    category: 'Kabin Memuru',
    description: 'Aciliyet yaratan son fırsat maili',
    thumbnail: 'https://images.unsplash.com/photo-1488085061387-422e29b40080?w=400&h=300&fit=crop',
    subject: '⏰ Son 48 saat - {{name}}, kabin memuru hayaliniz için',
    html: `<!DOCTYPE html>
<html>
<head><meta charset="utf-8"></head>
<body style="margin:0;padding:0;background:#fff;font-family:Arial,sans-serif;">
  <table width="100%" style="background:#fff;padding:20px;">
    <tr><td align="center">
      <table width="600" style="background:#fff;">
        <tr><td style="padding:40px 20px;">
          <div style="background:#fef2f2;padding:20px;border-radius:8px;margin-bottom:30px;text-align:center;">
            <p style="color:#991b1b;font-size:14px;margin:0;font-weight:600;text-transform:uppercase;">
              ⏰ Acil - Son 48 Saat
            </p>
          </div>
          
          <p style="color:#0f172a;font-size:16px;line-height:1.6;margin:0 0 20px 0;">
            Merhaba {{name}},
          </p>
          
          <p style="color:#0f172a;font-size:16px;line-height:1.8;margin:0 0 20px 0;">
            Size en son yazdığımda kabin memurluğu eğitimimize geri dönmeniz için davet etmiştim. 
            Hala cevap alamadım...
          </p>
          
          <p style="color:#0f172a;font-size:16px;line-height:1.8;margin:0 0 20px 0;">
            Belki meşgulsünüzdür, belki kararsızsınızdır. Anlıyorum. Ama size bir şey söylemeliyim:
          </p>
          
          <div style="background:#fff7ed;padding:30px;border-radius:12px;margin:30px 0;border:2px solid #fb923c;">
            <p style="color:#ea580c;font-size:18px;margin:0 0 20px 0;font-weight:600;text-align:center;">
              Bu Dönem Kapanıyor!
            </p>
            
            <p style="color:#0f172a;font-size:15px;margin:0 0 15px 0;line-height:1.8;">
              Şu anda açık olan dönemimiz <strong>Cuma günü sonu kapanıyor</strong>. 
              Bir sonraki dönem <strong>3 ay sonra</strong> başlayacak.
            </p>
            
            <p style="color:#0f172a;font-size:15px;margin:0;line-height:1.8;">
              Yani ya şimdi başlıyorsunuz, ya da 3 ay bekliyorsunuz. 
              <strong>3 ay</strong> - kabin memuru olmanız ve hayalinizdeki işte çalışmanız 
              arasındaki tek fark.
            </p>
          </div>
          
          <div style="background:#f0f9ff;padding:25px;border-radius:8px;margin:25px 0;">
            <p style="color:#1e40af;font-size:16px;margin:0 0 15px 0;font-weight:600;">
              Neden Şimdi Başlamalısınız?
            </p>
            <ul style="color:#1e40af;font-size:15px;margin:0;padding-left:20px;line-height:2;">
              <li>THY ve diğer havayolları <strong>Mart-Nisan'da</strong> yoğun alım yapıyor</li>
              <li>3 aylık programımızı bitirirseniz, <strong>tam zamanında</strong> hazır olacaksınız</li>
              <li>3 ay beklerseniz, fırsatları kaçıracaksınız</li>
            </ul>
          </div>
          
          <p style="color:#0f172a;font-size:16px;line-height:1.8;margin:0 0 20px 0;">
            {{name}}, bunu bir baskı olarak görmüyorum. Sadece gerçekler bunlar ve 
            sizi bilgilendirmek istedim.
          </p>
          
          <p style="color:#0f172a;font-size:16px;line-height:1.8;margin:0 0 25px 0;">
            <strong>Cuma günü</strong> saat <strong>23:59</strong>'a kadar kayıt olabilirsiniz. 
            Sonrasında bir sonraki dönem için bekleme listesine alınacaksınız.
          </p>
          
          <div style="text-align:center;margin:30px 0;">
            <a href="{{urgent_link}}" style="display:inline-block;background:#ef4444;color:#fff;padding:18px 45px;text-decoration:none;border-radius:8px;font-weight:600;font-size:18px;box-shadow:0 4px 6px rgba(239,68,68,0.3);">
              Evet, Son Şansımı Kullanıyorum
            </a>
          </div>
          
          <div style="background:#f8fafc;padding:20px;border-radius:8px;margin:25px 0;">
            <p style="color:#64748b;font-size:14px;margin:0;text-align:center;line-height:1.6;">
              Hala kararsız mısınız? Bu mail'e direkt cevap yazın, 15 dakikalık bir 
              görüşme yapalım. Tüm sorularınızı cevaplayalım, size özel bir plan çıkaralım.
            </p>
          </div>
          
          <p style="color:#0f172a;font-size:16px;line-height:1.6;margin:20px 0 0 0;">
            Kararınız her ne olursa olsun saygı duyuyorum,<br>
            <strong>{{sender_name}}</strong><br>
            <span style="color:#64748b;font-size:14px;">Son mail bu olacak, söz veriyorum 🙏</span>
          </p>
        </td></tr>
      </table>
    </td></tr>
  </table>
</body>
</html>`
  },
  
  {
    id: 'cabin-crew-free-demo',
    name: 'Ücretsiz Deneme',
    category: 'Kabin Memuru',
    description: 'Demo ders daveti',
    thumbnail: 'https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?w=400&h=300&fit=crop',
    subject: '{{name}}, size özel ücretsiz canlı ders daveti 🎁',
    html: `<!DOCTYPE html>
<html>
<head><meta charset="utf-8"></head>
<body style="margin:0;padding:0;background:#fff;font-family:Arial,sans-serif;">
  <table width="100%" style="background:#fff;padding:20px;">
    <tr><td align="center">
      <table width="600" style="background:#fff;">
        <tr><td style="padding:40px 20px;">
          <p style="color:#0f172a;font-size:16px;line-height:1.6;margin:0 0 20px 0;">
            Merhaba {{name}},
          </p>
          
          <p style="color:#0f172a;font-size:16px;line-height:1.8;margin:0 0 20px 0;">
            Eğitimimiz hakkında çok şey anlattım ama belki <strong>"Gerçekten bu kadar iyi mi?"</strong> 
            diye düşünüyorsunuz. Haklısınız! 😊
          </p>
          
          <p style="color:#0f172a;font-size:16px;line-height:1.8;margin:0 0 20px 0;">
            O yüzden size özel bir teklifim var...
          </p>
          
          <div style="background:linear-gradient(135deg,#dbeafe 0%,#bfdbfe 100%);padding:30px;border-radius:12px;margin:30px 0;text-align:center;">
            <h2 style="color:#1e40af;margin:0 0 15px 0;font-size:24px;">
              🎁 Ücretsiz Canlı Ders
            </h2>
            <p style="color:#1e40af;font-size:16px;margin:0;">
              Hiçbir ödeme yapmadan, sadece deneme amaçlı
            </p>
          </div>
          
          <div style="background:#fff;padding:30px;border-radius:12px;margin:30px 0;border:2px solid #e2e8f0;">
            <p style="color:#0f172a;font-size:16px;margin:0 0 20px 0;font-weight:600;">
              Bu Ücretsiz Derste:
            </p>
            
            <div style="margin-bottom:20px;">
              <div style="display:flex;align-items:start;gap:12px;">
                <span style="color:#10b981;font-size:20px;">✓</span>
                <div>
                  <p style="color:#0f172a;font-size:15px;margin:0 0 5px 0;font-weight:600;">
                    Native Speaker ile 30 Dakika İngilizce
                  </p>
                  <p style="color:#64748b;font-size:14px;margin:0;">
                    Gerçek bir derse katılacaksınız. Havacılık İngilizcesi temelleri.
                  </p>
                </div>
              </div>
            </div>
            
            <div style="margin-bottom:20px;">
              <div style="display:flex;align-items:start;gap:12px;">
                <span style="color:#10b981;font-size:20px;">✓</span>
                <div>
                  <p style="color:#0f172a;font-size:15px;margin:0 0 5px 0;font-weight:600;">
                    Ücretsiz Seviye Testi
                  </p>
                  <p style="color:#64748b;font-size:14px;margin:0;">
                    İngilizce seviyenizi öğrenin, size özel yol haritası çıkaralım.
                  </p>
                </div>
              </div>
            </div>
            
            <div style="margin-bottom:20px;">
              <div style="display:flex;align-items:start;gap:12px;">
                <span style="color:#10b981;font-size:20px;">✓</span>
                <div>
                  <p style="color:#0f172a;font-size:15px;margin:0 0 5px 0;font-weight:600;">
                    Soru-Cevap Oturumu
                  </p>
                  <p style="color:#64748b;font-size:14px;margin:0;">
                    Kabin memurluğu, mülakatlar, eğitim programı hakkında her şeyi sorun.
                  </p>
                </div>
              </div>
            </div>
            
            <div>
              <div style="display:flex;align-items:start;gap:12px;">
                <span style="color:#10b981;font-size:20px;">✓</span>
                <div>
                  <p style="color:#0f172a;font-size:15px;margin:0 0 5px 0;font-weight:600;">
                    Bonus: Kariyer Danışmanlığı
                  </p>
                  <p style="color:#64748b;font-size:14px;margin:0;">
                    Hangi havayoluna başvurmalısınız? CV'niz nasıl olmalı? Öğrenin.
                  </p>
                </div>
              </div>
            </div>
          </div>
          
          <div style="background:#fef3c7;padding:20px;border-radius:8px;margin:25px 0;text-align:center;">
            <p style="color:#92400e;font-size:15px;margin:0 0 10px 0;font-weight:600;">
              📅 Bu Hafta İçin Açık Slotlar:
            </p>
            <p style="color:#92400e;font-size:14px;margin:0;">
              Salı 14:00 | Çarşamba 19:00 | Perşembe 17:00 | Cuma 15:00
            </p>
          </div>
          
          <p style="color:#0f172a;font-size:16px;line-height:1.8;margin:0 0 25px 0;">
            {{name}}, kayıp bir şeyiniz yok! Tamamen ücretsiz, hiçbir yükümlülük yok. 
            Sadece gelip dinleyin, karar verin.
          </p>
          
          <div style="text-align:center;margin:30px 0;">
            <a href="{{demo_link}}" style="display:inline-block;background:#6366f1;color:#fff;padding:18px 45px;text-decoration:none;border-radius:8px;font-weight:600;font-size:18px;">
              Ücretsiz Derse Katıl
            </a>
          </div>
          
          <div style="background:#ecfdf5;padding:15px;border-radius:6px;margin:25px 0;">
            <p style="color:#065f46;font-size:13px;margin:0;text-align:center;">
              💳 Kredi kartı bilgisi istemiyoruz. Gerçekten ücretsiz!
            </p>
          </div>
          
          <p style="color:#0f172a;font-size:16px;line-height:1.6;margin:20px 0 0 0;">
            Görüşmek üzere! 👋<br>
            <strong>{{sender_name}}</strong>
          </p>
        </td></tr>
      </table>
    </td></tr>
  </table>
</body>
</html>`
  },
  
  {
    id: 'cabin-crew-personal-message',
    name: 'Kişisel Mesaj',
    category: 'Kabin Memuru',
    description: 'Samimi, 1-1 mesaj tarzı',
    thumbnail: 'https://images.unsplash.com/photo-1552664730-d307ca884978?w=400&h=300&fit=crop',
    subject: '{{name}}, sizinle konuşmak istiyorum',
    html: `<!DOCTYPE html>
<html>
<head><meta charset="utf-8"></head>
<body style="margin:0;padding:0;background:#fff;font-family:Arial,sans-serif;">
  <table width="100%" style="background:#fff;padding:20px;">
    <tr><td align="center">
      <table width="600" style="background:#fff;">
        <tr><td style="padding:40px 20px;">
          <p style="color:#0f172a;font-size:16px;line-height:1.6;margin:0 0 20px 0;">
            Merhaba {{name}},
          </p>
          
          <p style="color:#0f172a;font-size:16px;line-height:1.8;margin:0 0 20px 0;">
            Bu mail biraz farklı olacak. Pazarlama yok, teklifler yok. Sadece içimden 
            geldiği için yazıyorum.
          </p>
          
          <p style="color:#0f172a;font-size:16px;line-height:1.8;margin:0 0 20px 0;">
            Bir süre önce kabin memurluğu eğitimimize başvurdunuz ama devam etmediniz. 
            Her gün onlarca başvuru alıyorum ama sizin hikayenizi merak ettim.
          </p>
          
          <p style="color:#0f172a;font-size:16px;line-height:1.8;margin:0 0 20px 0;">
            <strong>Neden kabin memuru olmak istiyordunuz?</strong><br>
            <strong>Ne değişti? Neden vazgeçtiniz?</strong>
          </p>
          
          <p style="color:#0f172a;font-size:16px;line-height:1.8;margin:0 0 20px 0;">
            Merak etmeyin, bu soruları cevaplama yükümlülüğünüz yok. Ama eğer cevap vermek 
            isterseniz, sizinle samimi bir görüşme yapmak isterim.
          </p>
          
          <div style="background:#f8fafc;padding:25px;border-radius:10px;margin:30px 0;">
            <p style="color:#0f172a;font-size:16px;margin:0 0 15px 0;font-style:italic;line-height:1.8;">
              "Benim hikayem şuydu: 10 yıl önce ben de kabin memuru olmak istiyordum. 
              Aileme söyledim, 'Hayallerinin peşinden git' dediler. Ama korktum. 
              İngilizcem yeterli mi? Mülakata hazır mıyım? Ne olur olmaz diye vazgeçtim."
            </p>
            <p style="color:#64748b;font-size:14px;margin:15px 0 0 0;">
              5 yıl sonra tekrar denedim. Bu sefer hazırlandım. Ve oldu! THY'de 3 yıl çalıştım. 
              Şimdi size yardım ediyorum.
            </p>
          </div>
          
          <p style="color:#0f172a;font-size:16px;line-height:1.8;margin:0 0 20px 0;">
            Sizin hikayeniz ne? Hala kabin memuru olmak istiyor musunuz? Yoksa başka bir 
            yol mu buldunuz?
          </p>
          
          <p style="color:#0f172a;font-size:16px;line-height:1.8;margin:0 0 20px 0;">
            Eğer hala istiyorsanız, size nasıl yardımcı olabileceğimi düşünüyorum. 
            Eğer vazgeçtiyseniz, nedenini merak ediyorum - belki diğer adaylara yardımcı olur.
          </p>
          
          <p style="color:#0f172a;font-size:16px;line-height:1.8;margin:0 0 25px 0;">
            Bu mail'e cevap yazın. Hiçbir satış yok, sadece sohbet. 15 dakika, bir kahve, 
            samimi bir görüşme.
          </p>
          
          <p style="color:#0f172a;font-size:16px;line-height:1.8;margin:0 0 20px 0;">
            Cevap bekliyorum (ama zorunda değilsiniz 😊)
          </p>
          
          <p style="color:#0f172a;font-size:16px;line-height:1.6;margin:20px 0 0 0;">
            Saygılarımla,<br>
            <strong>{{sender_name}}</strong><br>
            <span style="color:#64748b;font-size:14px;">Eski Kabin Memuru, Şimdi Eğitmen</span><br>
            <span style="color:#64748b;font-size:14px;">{{phone}} (WhatsApp'tan da yazabilirsiniz)</span>
          </p>
          
          <div style="margin-top:30px;padding:15px;background:#f8fafc;border-radius:6px;">
            <p style="color:#64748b;font-size:13px;margin:0;font-style:italic;">
              Not: Bu mail'i sadece ben okuyacağım, otomatik sistem değil. 
              Gerçekten sizinle konuşmak istiyorum. 🙏
            </p>
          </div>
        </td></tr>
      </table>
    </td></tr>
  </table>
</body>
</html>`
  },
  
  {
    id: 'cabin-crew-guarantee',
    name: 'Öğretme Garantisi',
    category: 'Kabin Memuru',
    description: 'Risk-free garanti vurgusu',
    thumbnail: 'https://images.unsplash.com/photo-1552581234-26160f608093?w=400&h=300&fit=crop',
    subject: '{{name}}, öğrenemezseniz ücretsiz devam edin - garanti!',
    html: `<!DOCTYPE html>
<html>
<head><meta charset="utf-8"></head>
<body style="margin:0;padding:0;background:#fff;font-family:Arial,sans-serif;">
  <table width="100%" style="background:#fff;padding:20px;">
    <tr><td align="center">
      <table width="600" style="background:#fff;">
        <tr><td style="padding:40px 20px;">
          <p style="color:#0f172a;font-size:16px;line-height:1.6;margin:0 0 20px 0;">
            Merhaba {{name}},
          </p>
          
          <p style="color:#0f172a;font-size:16px;line-height:1.8;margin:0 0 20px 0;">
            Biliyorum, eğitime para vermek korkutucu olabilir. "Ya öğrenemezsem?" diye düşünüyorsunuz. 
            Haklısınız!
          </p>
          
          <p style="color:#0f172a;font-size:16px;line-height:1.8;margin:0 0 20px 0;">
            O yüzden size <strong>Türkiye'nin ilk ve tek</strong> şartını sunuyoruz:
          </p>
          
          <div style="background:#ecfdf5;padding:35px;border-radius:12px;margin:30px 0;border:3px solid #10b981;text-align:center;">
            <p style="color:#065f46;font-size:14px;margin:0 0 15px 0;font-weight:600;text-transform:uppercase;letter-spacing:1px;">
              %100 Öğretme Garantisi
            </p>
            <h2 style="color:#065f46;margin:0 0 20px 0;font-size:32px;font-weight:900;">
              🛡️ Öğrenme Garantisi
            </h2>
            <p style="color:#065f46;font-size:16px;margin:0;line-height:1.6;">
              3 ay sonunda hedef seviyeye ulaşamazsanız,<br>
              <strong style="font-size:20px;">TAMAMEN ÜCRETSİZ devam edin!</strong>
            </p>
          </div>
          
          <p style="color:#0f172a;font-size:16px;line-height:1.8;margin:0 0 20px 0;">
            Yani hiçbir riskiniz yok. Ya öğreneceksiniz, ya da bedavaya devam edeceksiniz. 
            Kazanan her türlü sizsiniz! 💪
          </p>
          
          <div style="background:#f8fafc;padding:25px;border-radius:10px;margin:30px 0;">
            <p style="color:#0f172a;font-size:16px;margin:0 0 15px 0;font-weight:600;">
              Garanti Koşulları (Çok Basit):
            </p>
            <ul style="color:#64748b;font-size:15px;margin:0;padding-left:20px;line-height:2;">
              <li>Derslerin %80'ine katılın</li>
              <li>Ödevleri yapın</li>
              <li>3 ay sonunda test olun</li>
              <li>Hedef seviyeye ulaşamadıysanız → Ücretsiz devam!</li>
            </ul>
          </div>
          
          <p style="color:#0f172a;font-size:16px;line-height:1.8;margin:0 0 20px 0;">
            <strong>Neden böyle bir garanti veriyoruz?</strong>
          </p>
          
          <p style="color:#0f172a;font-size:16px;line-height:1.8;margin:0 0 20px 0;">
            Çünkü sistemimize güveniyoruz. 7 yıldır bu işi yapıyoruz ve %96 başarı oranımız var. 
            Eğer siz %4'lük azınlıktaysanız, sizinle çalışmaya devam edeceğiz.
          </p>
          
          <div style="text-align:center;margin:30px 0;">
            <a href="{{guarantee_link}}" style="display:inline-block;background:#10b981;color:#fff;padding:18px 45px;text-decoration:none;border-radius:8px;font-weight:600;font-size:18px;">
              Risk-Free Başla
            </a>
          </div>
          
          <div style="background:#fffbeb;padding:20px;border-radius:8px;margin:25px 0;">
            <p style="color:#92400e;font-size:14px;margin:0;text-align:center;line-height:1.6;">
              💡 Sorularınız mı var? Bu mail'e direkt cevap yazın veya {{phone}} 
              numarasından WhatsApp yazın. Size garantiyi detaylı anlatalım.
            </p>
          </div>
          
          <p style="color:#0f172a;font-size:16px;line-height:1.6;margin:20px 0 0 0;">
            Güvenle başlayın! 🤝<br>
            <strong>{{sender_name}}</strong>
          </p>
        </td></tr>
      </table>
    </td></tr>
  </table>
</body>
</html>`
  },
  
  {
    id: 'cabin-crew-comparison',
    name: 'Karşılaştırma',
    category: 'Kabin Memuru',
    description: 'Diğer programlarla karşılaştırma',
    thumbnail: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=400&h=300&fit=crop',
    subject: '{{name}}, diğer eğitimlerle bizi karşılaştırdınız mı?',
    html: `<!DOCTYPE html>
<html>
<head><meta charset="utf-8"></head>
<body style="margin:0;padding:0;background:#fff;font-family:Arial,sans-serif;">
  <table width="100%" style="background:#fff;padding:20px;">
    <tr><td align="center">
      <table width="600" style="background:#fff;">
        <tr><td style="padding:40px 20px;">
          <p style="color:#0f172a;font-size:16px;line-height:1.6;margin:0 0 20px 0;">
            Merhaba {{name}},
          </p>
          
          <p style="color:#0f172a;font-size:16px;line-height:1.8;margin:0 0 20px 0;">
            Kabin memurluğu eğitimi araştırırken muhtemelen birçok farklı program gördünüz. 
            Normal! Doğru seçimi yapmak önemli.
          </p>
          
          <p style="color:#0f172a;font-size:16px;line-height:1.8;margin:0 0 20px 0;">
            Size şeffaf bir karşılaştırma yapmak istiyorum:
          </p>
          
          <div style="background:#fff;border-radius:12px;margin:30px 0;overflow:hidden;border:2px solid #e2e8f0;">
            <table width="100%" style="border-collapse:collapse;">
              <tr style="background:#f8fafc;">
                <th style="padding:15px;text-align:left;color:#64748b;font-size:14px;border-bottom:2px solid #e2e8f0;">Özellik</th>
                <th style="padding:15px;text-align:center;color:#ef4444;font-size:14px;border-bottom:2px solid #e2e8f0;">Diğerleri</th>
                <th style="padding:15px;text-align:center;color:#10b981;font-size:14px;border-bottom:2px solid #e2e8f0;">Biz</th>
              </tr>
              
              <tr style="border-bottom:1px solid #e2e8f0;">
                <td style="padding:15px;color:#0f172a;font-size:14px;">Canlı İngilizce Dersleri</td>
                <td style="padding:15px;text-align:center;font-size:20px;">❌</td>
                <td style="padding:15px;text-align:center;font-size:20px;">✅</td>
              </tr>
              
              <tr style="border-bottom:1px solid #e2e8f0;background:#fafafa;">
                <td style="padding:15px;color:#0f172a;font-size:14px;">Native Speaker</td>
                <td style="padding:15px;text-align:center;font-size:20px;">❌</td>
                <td style="padding:15px;text-align:center;font-size:20px;">✅</td>
              </tr>
              
              <tr style="border-bottom:1px solid #e2e8f0;">
                <td style="padding:15px;color:#0f172a;font-size:14px;">Mock-up Eğitimi</td>
                <td style="padding:15px;text-align:center;color:#f59e0b;font-size:14px;">Ücretli</td>
                <td style="padding:15px;text-align:center;color:#10b981;font-size:14px;font-weight:600;">Dahil!</td>
              </tr>
              
              <tr style="border-bottom:1px solid #e2e8f0;background:#fafafa;">
                <td style="padding:15px;color:#0f172a;font-size:14px;">1-1 Mülakat Provası</td>
                <td style="padding:15px;text-align:center;font-size:20px;">❌</td>
                <td style="padding:15px;text-align:center;font-size:20px;">✅</td>
              </tr>
              
              <tr style="border-bottom:1px solid #e2e8f0;">
                <td style="padding:15px;color:#0f172a;font-size:14px;">İşaret Dili Eğitimi</td>
                <td style="padding:15px;text-align:center;font-size:20px;">❌</td>
                <td style="padding:15px;text-align:center;font-size:20px;">✅</td>
              </tr>
              
              <tr style="border-bottom:1px solid #e2e8f0;background:#fafafa;">
                <td style="padding:15px;color:#0f172a;font-size:14px;">Diksiyon Koçluğu</td>
                <td style="padding:15px;text-align:center;font-size:20px;">❌</td>
                <td style="padding:15px;text-align:center;font-size:20px;">✅</td>
              </tr>
              
              <tr style="border-bottom:1px solid #e2e8f0;">
                <td style="padding:15px;color:#0f172a;font-size:14px;">Öğretme Garantisi</td>
                <td style="padding:15px;text-align:center;font-size:20px;">❌</td>
                <td style="padding:15px;text-align:center;font-size:20px;">✅</td>
              </tr>
              
              <tr style="background:#fafafa;">
                <td style="padding:15px;color:#0f172a;font-size:14px;font-weight:600;">Aylık Ücret</td>
                <td style="padding:15px;text-align:center;color:#ef4444;font-size:16px;font-weight:600;">₺4.500+</td>
                <td style="padding:15px;text-align:center;color:#10b981;font-size:16px;font-weight:600;">₺2.999</td>
              </tr>
            </table>
          </div>
          
          <p style="color:#0f172a;font-size:16px;line-height:1.8;margin:0 0 20px 0;">
            Rakamlar kendisi için konuşuyor. Ama daha önemlisi: <strong>Biz öğrencilerimize 
            değer veriyoruz.</strong>
          </p>
          
          <p style="color:#0f172a;font-size:16px;line-height:1.8;margin:0 0 25px 0;">
            Diğer programlarla kıyaslayın, araştırın, soruşturun. Sonra bu mail'e cevap yazın, 
            size detaylı bilgi vereyim.
          </p>
          
          <div style="text-align:center;margin:30px 0;">
            <a href="{{compare_link}}" style="display:inline-block;background:#6366f1;color:#fff;padding:16px 40px;text-decoration:none;border-radius:8px;font-weight:600;font-size:16px;">
              Detaylı Karşılaştırma Tablosu
            </a>
          </div>
          
          <p style="color:#0f172a;font-size:16px;line-height:1.6;margin:20px 0 0 0;">
            En iyi seçimi yapın,<br>
            <strong>{{sender_name}}</strong>
          </p>
        </td></tr>
      </table>
    </td></tr>
  </table>
</body>
</html>`
  },
  
  {
    id: 'cabin-crew-payment-plan',
    name: 'Ödeme Planı',
    category: 'Kabin Memuru',
    description: 'Esnek ödeme seçenekleri',
    thumbnail: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=400&h=300&fit=crop',
    subject: '{{name}}, bütçenize uygun ödeme planı hazırladık',
    html: `<!DOCTYPE html>
<html>
<head><meta charset="utf-8"></head>
<body style="margin:0;padding:0;background:#fff;font-family:Arial,sans-serif;">
  <table width="100%" style="background:#fff;padding:20px;">
    <tr><td align="center">
      <table width="600" style="background:#fff;">
        <tr><td style="padding:40px 20px;">
          <p style="color:#0f172a;font-size:16px;line-height:1.6;margin:0 0 20px 0;">
            Merhaba {{name}},
          </p>
          
          <p style="color:#0f172a;font-size:16px;line-height:1.8;margin:0 0 20px 0;">
            En çok duyduğum cümle: <em>"Eğitim çok iyi ama şu an bütçem müsait değil."</em>
          </p>
          
          <p style="color:#0f172a;font-size:16px;line-height:1.8;margin:0 0 20px 0;">
            Sizi anlıyorum. O yüzden size <strong>esnek ödeme seçenekleri</strong> hazırladık:
          </p>
          
          <div style="background:#f8fafc;padding:30px;border-radius:12px;margin:30px 0;">
            <h3 style="color:#0f172a;margin:0 0 25px 0;font-size:20px;text-align:center;">
              💳 Ödeme Seçenekleri
            </h3>
            
            <div style="background:#fff;padding:25px;border-radius:10px;margin-bottom:20px;border:2px solid #10b981;">
              <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:15px;">
                <p style="color:#0f172a;font-size:18px;margin:0;font-weight:600;">Peşin Ödeme</p>
                <span style="background:#10b981;color:#fff;padding:5px 15px;border-radius:20px;font-size:12px;font-weight:600;">%15 İNDİRİM</span>
              </div>
              <p style="color:#10b981;font-size:32px;margin:0;font-weight:900;">₺7.650</p>
              <p style="color:#64748b;font-size:14px;margin:5px 0 0 0;"><s>₺9.000</s> Yerine</p>
            </div>
            
            <div style="background:#fff;padding:25px;border-radius:10px;margin-bottom:20px;border:2px solid #3b82f6;">
              <p style="color:#0f172a;font-size:18px;margin:0 0 10px 0;font-weight:600;">3 Taksit</p>
              <p style="color:#3b82f6;font-size:28px;margin:0;font-weight:900;">₺3.000</p>
              <p style="color:#64748b;font-size:14px;margin:5px 0 0 0;">Aylık (Toplam: ₺9.000)</p>
            </div>
            
            <div style="background:#fff;padding:25px;border-radius:10px;margin-bottom:20px;border:2px solid #f59e0b;">
              <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:15px;">
                <p style="color:#0f172a;font-size:18px;margin:0;font-weight:600;">6 Taksit</p>
                <span style="background:#f59e0b;color:#fff;padding:5px 15px;border-radius:20px;font-size:12px;font-weight:600;">POPÜLER</span>
              </div>
              <p style="color:#f59e0b;font-size:28px;margin:0;font-weight:900;">₺1.650</p>
              <p style="color:#64748b;font-size:14px;margin:5px 0 0 0;">Aylık (Toplam: ₺9.900)</p>
            </div>
            
            <div style="background:#fff;padding:25px;border-radius:10px;border:2px solid #e2e8f0;">
              <p style="color:#0f172a;font-size:18px;margin:0 0 10px 0;font-weight:600;">Öğrenci İndirimi</p>
              <p style="color:#6366f1;font-size:28px;margin:0;font-weight:900;">₺2.400</p>
              <p style="color:#64748b;font-size:14px;margin:5px 0 0 0;">Aylık 3 taksit (Toplam: ₺7.200)</p>
            </div>
          </div>
          
          <div style="background:#ecfdf5;padding:20px;border-radius:8px;margin:25px 0;">
            <p style="color:#065f46;font-size:15px;margin:0;text-align:center;font-weight:600;">
              ✅ Tüm paketlerde: Öğretme garantisi + Sınırsız ders tekrarı + 1 yıl kayıt erişimi
            </p>
          </div>
          
          <p style="color:#0f172a;font-size:16px;line-height:1.8;margin:0 0 20px 0;">
            {{name}}, bütçenize en uygun planı birlikte belirleyelim. Bu mail'e cevap yazın 
            veya arayın, size özel bir teklif hazırlayayım.
          </p>
          
          <div style="text-align:center;margin:30px 0;">
            <a href="{{payment_link}}" style="display:inline-block;background:#10b981;color:#fff;padding:16px 40px;text-decoration:none;border-radius:8px;font-weight:600;font-size:16px;">
              Ödeme Planlarını İncele
            </a>
          </div>
          
          <div style="background:#dbeafe;padding:15px;border-radius:6px;margin:25px 0;">
            <p style="color:#1e40af;font-size:13px;margin:0;text-align:center;">
              💬 Özel indirim kodu için bu mail'e "İNDİRİM" yazın!
            </p>
          </div>
          
          <p style="color:#0f172a;font-size:16px;line-height:1.6;margin:20px 0 0 0;">
            Hayalleriniz bütçenize kurban olmasın,<br>
            <strong>{{sender_name}}</strong><br>
            <span style="color:#64748b;font-size:14px;">{{phone}} (WhatsApp)</span>
          </p>
        </td></tr>
      </table>
    </td></tr>
  </table>
</body>
</html>`
  },
  
  {
    id: 'cabin-crew-urgency',
    name: 'Aciliyet - Kontenjan',
    category: 'Kabin Memuru',
    description: 'Son kontenjan uyarısı',
    thumbnail: 'https://images.unsplash.com/photo-1506784983877-45594efa4cbe?w=400&h=300&fit=crop',
    subject: '⚠️ {{name}}, sadece 7 kontenjan kaldı!',
    html: `<!DOCTYPE html>
<html>
<head><meta charset="utf-8"></head>
<body style="margin:0;padding:0;background:#fff;font-family:Arial,sans-serif;">
  <table width="100%" style="background:#fff;padding:20px;">
    <tr><td align="center">
      <table width="600" style="background:#fff;">
        <tr><td style="padding:40px 20px;">
          <div style="background:#fef2f2;padding:25px;border-radius:8px;margin-bottom:30px;text-align:center;border:2px solid #ef4444;">
            <p style="color:#991b1b;font-size:16px;margin:0 0 10px 0;font-weight:600;text-transform:uppercase;">
              ⚠️ Acil Durum
            </p>
            <p style="color:#991b1b;font-size:36px;margin:0;font-weight:900;">7</p>
            <p style="color:#991b1b;font-size:16px;margin:5px 0 0 0;font-weight:600;">
              Kontenjan Kaldı
            </p>
          </div>
          
          <p style="color:#0f172a;font-size:16px;line-height:1.6;margin:0 0 20px 0;">
            Merhaba {{name}},
          </p>
          
          <p style="color:#0f172a;font-size:16px;line-height:1.8;margin:0 0 20px 0;">
            Kötü bir haberim var...
          </p>
          
          <p style="color:#0f172a;font-size:16px;line-height:1.8;margin:0 0 20px 0;">
            Bu dönemin kontenjanı dolmak üzere. Şu anda sadece <strong>7 kişilik</strong> 
            yer kaldı ve son 48 saatte 12 kayıt oldu.
          </p>
          
          <div style="background:#fffbeb;padding:25px;border-radius:10px;margin:30px 0;border-left:4px solid #f59e0b;">
            <p style="color:#92400e;font-size:15px;margin:0 0 15px 0;font-weight:600;">
              Neden Kontenjan Sınırlı?
            </p>
            <p style="color:#92400e;font-size:14px;margin:0;line-height:1.8;">
              Her öğrenciye <strong>1-1 mülakat provası</strong> ve <strong>kişisel coaching</strong> 
              veriyoruz. 40 kişiden fazla alırsak kalite düşer. Biz bunu istemiyoruz.
            </p>
          </div>
          
          <div style="background:#f8fafc;padding:30px;border-radius:12px;margin:30px 0;border:2px solid #e2e8f0;">
            <p style="color:#0f172a;font-size:16px;margin:0 0 20px 0;font-weight:600;text-align:center;">
              Bu Dönem Dolunca:
            </p>
            
            <div style="background:#fef2f2;padding:20px;border-radius:8px;margin-bottom:15px;">
              <p style="color:#991b1b;font-size:15px;margin:0 0 8px 0;font-weight:600;">
                ❌ 3 Ay Bekleme Listesi
              </p>
              <p style="color:#991b1b;font-size:14px;margin:0;">
                Bir sonraki dönem Mart ayında başlayacak. 3 ay ertelenmiş hayaller...
              </p>
            </div>
            
            <div style="background:#fef2f2;padding:20px;border-radius:8px;margin-bottom:15px;">
              <p style="color:#991b1b;font-size:15px;margin:0 0 8px 0;font-weight:600;">
                ❌ Havayolu Alımlarını Kaçırma
              </p>
              <p style="color:#991b1b;font-size:14px;margin:0;">
                THY ve Pegasus, Mart-Nisan'da alım yapıyor. Şimdi başlamazsanız hazır olamazsınız.
              </p>
            </div>
            
            <div style="background:#fef2f2;padding:20px;border-radius:8px;">
              <p style="color:#991b1b;font-size:15px;margin:0 0 8px 0;font-weight:600;">
                ❌ Fiyat Artışı
              </p>
              <p style="color:#991b1b;font-size:14px;margin:0;">
                Gelecek dönem fiyat ₺3.500 olacak. Şimdi kayıt olursanız ₺2.999.
              </p>
            </div>
          </div>
          
          <p style="color:#0f172a;font-size:16px;line-height:1.8;margin:0 0 20px 0;">
            {{name}}, bu mail'i size baskı yapmak için değil, <strong>bilgilendirmek</strong> 
            için yazıyorum. Karar sizin.
          </p>
          
          <p style="color:#0f172a;font-size:16px;line-height:1.8;margin:0 0 25px 0;">
            Ama eğer bu dönem başlamak istiyorsanız, <strong>bu mail'e hemen cevap yazın</strong>. 
            Son kontenjanlara öncelikli giriş sağlayalım.
          </p>
          
          <div style="text-align:center;margin:30px 0;">
            <a href="{{urgent_register}}" style="display:inline-block;background:#ef4444;color:#fff;padding:18px 45px;text-decoration:none;border-radius:8px;font-weight:600;font-size:18px;">
              Hemen Kayıt Ol (7 Kişilik Yer)
            </a>
          </div>
          
          <div style="background:#f0fdf4;padding:20px;border-radius:8px;margin:25px 0;text-align:center;">
            <p style="color:#065f46;font-size:14px;margin:0;">
              🎁 İlk 5 kayıta özel: Ücretsiz diksiyon eğitimi paketi!
            </p>
          </div>
          
          <p style="color:#0f172a;font-size:16px;line-height:1.6;margin:20px 0 0 0;">
            Son şansı değerlendirin,<br>
            <strong>{{sender_name}}</strong><br>
            <span style="color:#64748b;font-size:14px;">{{phone}} (Acil WhatsApp)</span>
          </p>
        </td></tr>
      </table>
    </td></tr>
  </table>
</body>
</html>`
  },
  
  {
    id: 'cabin-crew-faq',
    name: 'Sıkça Sorulan Sorular',
    category: 'Kabin Memuru',
    description: 'Yaygın soruların cevapları',
    thumbnail: 'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=400&h=300&fit=crop',
    subject: '{{name}}, aklınızdaki 5 soruyu cevaplıyorum',
    html: `<!DOCTYPE html>
<html>
<head><meta charset="utf-8"></head>
<body style="margin:0;padding:0;background:#fff;font-family:Arial,sans-serif;">
  <table width="100%" style="background:#fff;padding:20px;">
    <tr><td align="center">
      <table width="600" style="background:#fff;">
        <tr><td style="padding:40px 20px;">
          <p style="color:#0f172a;font-size:16px;line-height:1.6;margin:0 0 20px 0;">
            Merhaba {{name}},
          </p>
          
          <p style="color:#0f172a;font-size:16px;line-height:1.8;margin:0 0 20px 0;">
            Eğitimimiz hakkında size çok şey anlattım ama belki aklınızda sorular var. 
            En çok sorulan 5 soruya cevap veriyorum:
          </p>
          
          <div style="background:#fff;border-radius:12px;margin:30px 0;">
            <div style="background:#f8fafc;padding:25px;border-radius:8px;margin-bottom:20px;border-left:4px solid #6366f1;">
              <p style="color:#6366f1;font-size:15px;margin:0 0 10px 0;font-weight:600;">
                ❓ İngilizcemi yeterli değil, yetişir mi?
              </p>
              <p style="color:#0f172a;font-size:14px;margin:0;line-height:1.8;">
                <strong>Cevap:</strong> Kesinlikle! A2 seviyesinden B2'ye 3 ayda ulaşan yüzlerce 
                öğrencimiz var. Canlı derslerimizle her gün pratik yapıyorsunuz. Öğretme garantimiz var!
              </p>
            </div>
            
            <div style="background:#f8fafc;padding:25px;border-radius:8px;margin-bottom:20px;border-left:4px solid #6366f1;">
              <p style="color:#6366f1;font-size:15px;margin:0 0 10px 0;font-weight:600;">
                ❓ İş garantisi var mı?
              </p>
              <p style="color:#0f172a;font-size:14px;margin:0;line-height:1.8;">
                <strong>Dürüst cevap:</strong> Hayır. Hiç kimse iş garantisi veremez. Ama 
                %89 öğrencimiz ilk mülakatlarında başarılı oluyor. Size en iyi hazırlığı veriyoruz, 
                geri kalanı sizin çabanız.
              </p>
            </div>
            
            <div style="background:#f8fafc;padding:25px;border-radius:8px;margin-bottom:20px;border-left:4px solid #6366f1;">
              <p style="color:#6366f1;font-size:15px;margin:0 0 10px 0;font-weight:600;">
                ❓ Yaşım büyük, 28 yaşındayım, geç mi?
              </p>
              <p style="color:#0f172a;font-size:14px;margin:0;line-height:1.8;">
                <strong>Cevap:</strong> Hayır! Havayolları 18-32 yaş arası alım yapıyor. 32 yaşındaki 
                öğrencilerimiz bile başarılı oldu. Önemli olan hazırlık ve özgüven.
              </p>
            </div>
            
            <div style="background:#f8fafc;padding:25px;border-radius:8px;margin-bottom:20px;border-left:4px solid #6366f1;">
              <p style="color:#6366f1;font-size:15px;margin:0 0 10px 0;font-weight:600;">
                ❓ Online eğitim yeterli mi? Uygulamalı olmaz mı?
              </p>
              <p style="color:#0f172a;font-size:14px;margin:0;line-height:1.8;">
                <strong>Cevap:</strong> Teorik derslerimiz online, ama <strong>mock-up eğitimleri 
                İstanbul'da gerçek uçak kabininde</strong> yapılıyor. Hem online hem fiziksel!
              </p>
            </div>
            
            <div style="background:#f8fafc;padding:25px;border-radius:8px;border-left:4px solid #6366f1;">
              <p style="color:#6366f1;font-size:15px;margin:0 0 10px 0;font-weight:600;">
                ❓ Çalışıyorum, zaman bulamam. Esnek mi?
              </p>
              <p style="color:#0f172a;font-size:14px;margin:0;line-height:1.8;">
                <strong>Cevap:</strong> Evet! Canlı derslere katılamazsanız, kayıtlarını izleyebilirsiniz. 
                Tüm dersler 1 yıl boyunca erişilebilir. Kendi hızınızda ilerleyin.
              </p>
            </div>
          </div>
          
          <p style="color:#0f172a;font-size:16px;line-height:1.8;margin:0 0 20px 0;">
            {{name}}, başka sorunuz var mı? Bu mail'e direkt cevap yazın, 
            samimi bir görüşme yapalım.
          </p>
          
          <div style="text-align:center;margin:30px 0;">
            <a href="{{faq_link}}" style="display:inline-block;background:#6366f1;color:#fff;padding:16px 40px;text-decoration:none;border-radius:8px;font-weight:600;font-size:16px;">
              Tüm SSS'leri Görüntüle
            </a>
          </div>
          
          <div style="background:#ecfdf5;padding:20px;border-radius:8px;margin:25px 0;">
            <p style="color:#065f46;font-size:14px;margin:0;text-align:center;">
              📞 Hemen konuşmak isterseniz: {{phone}} (WhatsApp mesaj atın!)
            </p>
          </div>
          
          <p style="color:#0f172a;font-size:16px;line-height:1.6;margin:20px 0 0 0;">
            Tüm sorularınızı yanıtlamaya hazırım,<br>
            <strong>{{sender_name}}</strong>
          </p>
        </td></tr>
      </table>
    </td></tr>
  </table>
</body>
</html>`
  }
];

export const templateCategories = [
  { id: 'all', name: 'Tümü', icon: '📧' },
  { id: 'Kabin Memuru', name: 'Havacılık', icon: '✈️' }
];
